"use client";
import { isTvEnv } from "@/utils/common.helpers";
import { useEffect } from "react";

const InitPolyfills = () => {
  useEffect(() => {
    // Dynamically import polyfill to avoid importing on server-side
    // This polyfill adds requestSubmit() support for older browsers
    if (isTvEnv()) {
      import("form-request-submit-polyfill").catch((error) => {
        console.warn("form-request-submit-polyfill failed to load", error);
      });
    }
  }, []);
  return null;
};

export default InitPolyfills;
